/**
 * 通信系の定数管理
 */
// 接続先
export const ADMIN_BASE = '/admin'
export const ADMIN_ENDPOINT = `${ADMIN_BASE}/api/v1`
export const DRIVER_BASE = '/driver'
export const DRIVER_ENDPOINT = `${DRIVER_BASE}/api/v1`
export const EDI_REQUEST_BASE = '/edi-request'
export const EDI_REQUEST_ENDPOINT = `${EDI_REQUEST_BASE}/api/v1`

// 招待のステッパー
export const INVITATION_USER_STEPPER = 'invitationUserStepper'

